export enum MessageType {
    SignInError = 'signInError',
    SsoError = 'ssoError',
    LaunchpadError = 'launchpadError',
    SruSuccess = 'sruSuccess',
    SruError = 'sruError',
}

const SignInErrorMessages: Record<string, string> = {
    noPermission: 'You are not authorized to use this application. To get access, please contact support.',
    sessionExpired: 'Your session has ended. Please log in again.',
    serviceUnavailable: 'There has been an unexpected error. Please try again. If the problem persists, please contact support.',
};

const SignInErrorQueryMessages: Record<string, Record<string, string>> = {
    invalidRedirectUri: { true: 'There was a problem logging you in. Please try again later.' },
    invalidResetPassword: { true: 'The link to reset your password has either already been used or has expired. Please re-enter your email to receive a new password reset link.' },
    type: { passwordResetMessage: 'Your password has been reset. Please continue by logging in with your new password. New passwords will be updated for Fitch Connect Web, Excel, and API Applications.' },
};

const SsoErrorMessages: Record<string, string> = {
    addUserToGroupsFail: 'Single Sign-on could not be authorized, user could not be added to required groups.',
    groupLimitExceeded: 'Single Sign-on group user limit reached for organization, cannot complete authorization.',
    invalidOrganization: 'Single Sign-on was used with an incorrect organization. Please use the organization that you belong to.',
    invalidOauthCallback: 'Single Sign-on could not be authorized, invalid callback request provided.',
    invalidSsoOrganization: 'Single Sign-on is not configured for organization, cannot complete authorization.',
    invalidUrl: 'Single Sign-on could not be authorized, invalid initial URL provided.',
    organizationNotFound: 'Single Sign-on could not be authorized, organization information could not be found.',
    userNotSamlEnabled: 'Single Sign-on could not be authorized, user is not SAML enabled.',
    userRejectedException: 'Single Sign-on could not be authorized, user does not meet organization’s access requirements.',
    userSyncError: 'Single Sign-on could not be authorized, invalid user attributes provided.',
    userTokenError: 'Single Sign-on could not be authorized, failed to generate user token.',
    unavailable: 'Single Sign-on is currently unavailable. Please try again later.',
};

const LaunchpadErrorMessages: Record<string, string> = {
    usernamePasswordNotAllowed: 'You are not authorized to log in. Please contact Client Services for access.',
    ssoNotAllowed: 'Single Sign-on cannot be initiated for this Login. Please contact Client Services.',
    ipAuthNotAllowed: 'IP Authentication cannot be initiated for this Login. Please contact Client Services.',
};

const SruSuccessMessages: Record<string, string> = {
    verifiedSuccessfully: 'Thank you! Your account has been successfully verified.',
    alreadyVerified: 'Email has already been verified, please log in.',
};

const SruErrorMessages: Record<string, string> = {
    noToken: 'Sorry, no token was provided for verification. Please enter your email again.',
    invalidToken: 'Sorry, the token that was provided is invalid for verification. Please enter your email again.',
    expiredToken: 'Sorry, the link has expired. Please enter your email address again.',
    alreadyVerified: 'Email has already been verified, please log in.',
    failedVerification: 'Sorry, we were unable to verify your email at this time. Please try using your email verification link again later.',
};

function getErrorMessage(messageCode: string, messageType: MessageType, queryParam?: string): string {
    switch (messageType) {
        case MessageType.SignInError:
            return queryParam ? SignInErrorQueryMessages[queryParam]?.[messageCode] || '' : SignInErrorMessages[messageCode] || '';
        case MessageType.SsoError:
            return SsoErrorMessages[messageCode] || '';
        case MessageType.LaunchpadError:
            return LaunchpadErrorMessages[messageCode] || '';
        case MessageType.SruSuccess:
            return SruSuccessMessages[messageCode] || '';
        case MessageType.SruError:
            return SruErrorMessages[messageCode] || '';
        default:
            return '';
    }
}

export function getBannerMessage(messageCode: string, messageType: MessageType, queryParam?: string): string {
    return getErrorMessage(messageCode, messageType, queryParam);
}  